import { Constant } from '../constant';
import { Component, OnInit, HostListener } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { ToastUtil } from '../util/toast-util';
import { CommonUtil } from '../util/common-util';
import { Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { PassCompDialogComponent } from '../dialog/pass-comp-dialog/pass-comp-dialog.component';
import { Auth } from '@aws-amplify/auth';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.css'],
    providers: [Title],
    standalone: false
})
export class SignUpComponent implements OnInit {
  public readonly Constant = Constant;
  public changeForm: FormGroup;
  public showSpinner = true;
  public isSaving = false;
  private apiPath = '/signup';
  private companyCode: string;
  public commentMaxLength = false; // コメントの入力制御

  constructor(
    private router: Router,
    private auth: AuthService,
    private toastUtil: ToastUtil,
    private commonUtil: CommonUtil,
    private activatedRoute: ActivatedRoute,
    private title: Title,
    private dialog: MatDialog
  ) {
    this.companyCode = this.activatedRoute.snapshot.params['code'];
    this.title.setTitle(Constant.pageTitleCreateAccount + Constant.pageTitleCommon);
  }

  ngOnInit() {
    window.scroll(0, 0);
    const companyName = localStorage.getItem(Constant.lsCompanyName);
    if (companyName) {
      this.auth.isAuthenticated().subscribe(result => {
        if (result) {
          // ログイン済み
          this.router.navigate(['myevent']);
        }
      });
    }
    this.changeForm = new FormGroup(
      {
        user_id: new FormControl('', [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(100),
          Validators.pattern(/^[\x21-\x7E]+$/)
        ]),
        password: new FormControl('', [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\x20-\x7E]+$/)
        ]),
        passwordConfirm: new FormControl('', [Validators.required]),
        comment: new FormControl('', [
          Validators.maxLength(100)
        ])
      },
      this.pwdMatchValidator
    );
    this.showSpinner = false;
  }

  onSignUp() {

    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    if (this.newPassword?.invalid) {
      this.toastUtil.showErrorToast(
        '',
        'パスワードは英字と数字を含む8桁以上で設定してください。',
        Constant.toastShowMiliSec
      );
      return;
    }

    localStorage.setItem(Constant.lsCompanyCode, this.companyCode);
    const options = this.auth.createApiHeaderBeforeLogin();
    options['body'] = {
      companycode: localStorage.getItem(Constant.lsCompanyCode),
      user_id: this.changeForm.value.user_id,
      password: this.changeForm.value.password,
      comment: this.changeForm.value.comment
    }
    this.commonUtil
      .apiPost(this.apiPath, options)
      .then(res => {
        if (res.status === Constant.OK) {
          this.toastUtil.showInformationToast('', Constant.msgAccountCreateSuccess, Constant.toastShowMiliSec);
          this.router.navigate(['/login/' + localStorage.getItem(Constant.lsCompanyCode)]);
          this.isSaving = false;
        }
      }).catch(err => {
        this.commonUtil.debug().log(err);
        if(err.message =='このIDは既に使用されています。'){
          this.toastUtil.showErrorToast('', Constant.msgAccountIdDuplicateError, Constant.toastShowMiliSec);
          this.isSaving = false;
        } else if(err.message =='パスワードは英字と数字を含む8桁以上で設定してください。'){
          this.toastUtil.showErrorToast('', 'パスワードは英字と数字を含む8桁以上で設定してください。', Constant.toastShowMiliSec);
          this.isSaving = false;
        } else {
          this.toastUtil.showErrorToast('', Constant.msgAccountCreateError, Constant.toastShowMiliSec);
          this.isSaving = false;
        }
      });
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  onInput(target, maxLenFlg, maxLenCnt) {
    const formName = target.getAttribute('formControlName');
    const beforeText = target.value;
    const changeText = beforeText.replace(/\r?\n/g, '');
    this.changeForm.patchValue({[formName]: beforeText});
    // 改行不可の入力欄に改行入りテキストがペーストされた場合は改行無しに変換したテキストに置き換える
    if (beforeText !== changeText) {
      this.changeForm.patchValue({[formName]: changeText});
    }

    // 入力内容が最大文字数制限を超えた場合は各フラグをtrueにする
    if (target.value.length > maxLenCnt) {
      this[maxLenFlg] = true;
    } else {
      this[maxLenFlg] = false;
    }
  }

  countInputText(txt) {
    return txt.length;
  }

  // 利用規約
  onAgreement() {
    window.open(Constant.footerUrlAgreement);
  }

  onLogin() {
    this.router.navigate(['/login/' + this.companyCode]);
  }

  // プライバシーポリシー
  onPrivacy() {
    window.open(Constant.footerUrlPrivacy);
  }

  get newPassword() {
    return this.changeForm.get('password');
  }

  get newPasswordConfirm() {
    return this.changeForm.get('passwordConfirm');
  }

  pwdMatchValidator(frm: FormGroup) {
    if (frm.get('password').value !== frm.get('passwordConfirm').value) {
      return { mismatch: true };
    }
    return null;
  }

  // トースト表示
  private showError(msg: string) {
    this.toastUtil.clearAllShowingToast();
    this.toastUtil.showErrorToast('', msg, Constant.toastShowMiliSec);
    this.showSpinner = false;
  }

}
